import React from 'react';
import { withTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { AppQRCode } from '../components';
import { appStore } from '../redux-saga/store';

const App = () => (
  <Provider store={appStore}>
    <AppQRCode />
  </Provider>
);

export default withTranslation()(App);
